<template>
  <div>
  <form @submit.prevent="sendComment" @keyup.shift.enter="sendComment" class="container" onkeypress="if(event.shiftKey==true){if(event.keyCode==13){event.returnValue=false}}">
  <div class="row">
    <a v-b-modal.modal1 :class="{ 'image-uploaded' : uploadImage }" class="col-sm-1 add-photo" href="#"><i class="fa fa-picture-o"></i></a>
    <a v-b-modal.modal2 class="col-sm-1 send-stamp" href="#"><i class="fa fa-smile-o"></i></a>
    <div class="col-sm-10 comment-input">
      <div class="input-group">
      <!-- <div v-html="this.$refs.commentForm.textContent"></div>
      <div>{{this.$refs.commentForm.textContent}}</div> -->
      <!-- {{this.checkForm}} -->
      <div @click="focusComment" class="form-control">
        <span class="reply-tag" :class="{'reply-active' : replyUser}">{{ replyUser }}<i @click="onClickReplyReset" class="fa fa-times cursor"></i></span>
        <!-- <div ref="commentForm" class="context-form" contenteditable="true"></div> -->
        <autosize-textarea v-model="textContent" ref="commentForm">
        </autosize-textarea>
        <!-- <textarea v-model="textContent" ref="commentForm" class="context-form"></textarea> -->
      </div>
      <span class="input-group-btn">
        <button type="submit" class="btn btn-white send-button" :disabled="!canSubmit">{{ $t('senderTitle') }}</button>
      </span>
      </div>
    </div>
  </div>
</form>
<b-modal id="modal1" :title="$t('changePictureStr')" :ok-title="$t('uploadPictureStr')" ref="modal" @hide="handleClickEvent">
  <div style="display: inline-block;">
    <toggle-button v-model="isEnableCrop"
      :labels= "isEnableCropToggleStr"
      :sync="true"
      :width="80"/>
    <span style="display: inline-block;">
      <label>
        <span class="btn btn-primary">
          Choose Image<input type="file" accept='image/*' @change="onPictureSelected" style="display:none" v-if="flagForReset" ref="fileInputForm">
        </span>
      </label>
    </span>
    <span style="display: inline-block;">
      <button class="btn btn-danger" @click="removeCroppa">Delete Image</button>
    </span>
    <span style="display: inline-block">
      <button class="btn btn-secondary" style="background-color: gray" @click="rotateImage(-90)">
        <img :src="'static/img/assets/rotate_left_icon.png'" width="30" height="30">
      </button>
    </span>
    <span style="display: inline-block">
      <button class="btn btn-secondary" style="background-color: gray" @click="rotateImage(90)">
        <img :src="'static/img/assets/rotate_right_icon.png'" width="30" height="30">
      </button>
    </span>
  </div>
  <vue-cropper
        v-if="hasCropperImage"
        ref='cropper'
        :guides="true"
        :view-mode="2"
        :drag-mode="'crop'"
        :auto-crop-area="1.0"
        :zoomable="true"
        :min-container-width="300"
        :min-container-height="300"
        :background="true"
        :rotatable="true"
        :src="uploadImage"
        :img-style="{ 'width': '300px', 'height': '300px' }">
  </vue-cropper>
  <div v-if="!isLoaded" class="spinner" />

         <!-- <input type="file" v-on:change="onFileChange"> -->
</b-modal>
<b-modal id="modal2" centered :title="$t('selectStampStr')" :ok-title="$t('sendStamp')" ref="stampModal" @hide="handleStampClickEvent">
  <div class="flex-display">
    <div v-for="(item, idx) of stamps" v-bind:key="'item' + idx">
      <li class="select-stamps"><label>
        <input type="radio" v-model="selectedStamp" v-bind:value="item" v-on:click="onClickStamp(item)" class="checkbox stamp-check">
        <div><img :src="StampToUrl(item)" :alt="item" ></div>
      </label></li>
    </div>
  </div>
</b-modal>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { storage, stamps, stampsurl } from '@/main'
import moment from 'moment'
import VueCropper from 'vue-cropperjs'
import AutosizeTextarea from '@/components/AutosizeTextarea'
// function getText (el) {
//   // let element = document.querySelector('div[contenteditable]')
//   let element = el
//   console.log('element::', element)
//   let firstTag = element.firstChild.nodeName
//   console.log('firstTag::', firstTag)
//   let keyTag = new RegExp(
//     firstTag === '#text' ? '<br' : '</' + firstTag,
//     'i'
//   )
//   let tmp = document.createElement('p')
//   console.log('tmp::', tmp)
//   tmp.innerHTML = element.innerHTML
//     .replace(/<[^>]+>/g, (m, i) => (keyTag.test(m) ? '{ß®}' : ''))
//     .replace(/{ß®}$/, '')
//   console.log('tmp.innerHTML::', tmp.innerHTML)
//   console.log('tmp.innerText.replace::', tmp.innerText.replace(/{ß®}/g, '\n'))
//   return tmp.innerText.replace(/{ß®}/g, '\n')
// }

export default {
  name: 'CommentForm',
  props: {
    target: String,
    targetId: String,
    userId: String,
    targetOwner: String
  },
  components: {
    VueCropper,
    AutosizeTextarea
  },
  data () {
    return {
      isEnableCrop: false,
      stamps: stamps,
      cropImage: '',
      myCroppa: {},
      flagForReset: true,
      replyUser: '',
      fileInfo: {},
      watchTargetId: this.checkTargetId,
      comment: {
        contentText: '',
        createdAt: '',
        target: '',
        targetId: '',
        userId: '',
        userName: '',
        isStamp: ''
      },
      parentInfo: {
        parentId: '',
        parentUserId: '',
        parentUserName: '',
        RootParentId: ''
      },
      Reloadstamps: {},
      uploadImage: '',
      hasCropperImage: false,
      isImageUploading: false,
      textContent: '',
      selectedStamp: '',
      isLoaded: true
    }
  },
  computed: {
    ...mapGetters([
      'getUserId',
      'getCurrentUserInfo'
    ]),
    ...mapGetters('users/', [
      'getUserInfoById'
    ]),
    checkTarget () {
      let targetObject = {
        Id: this.targetId,
        type: this.target
      }
      return targetObject
    },
    canSubmit () {
      return (!this.hasCropperImage || !this.isImageUploading)
    },
    checkForm () {
      return this.$refs.commentForm
    },
    isEnableCropToggleStr () {
      return {
        checked: 'Edit ON',
        unchecked: 'Edit OFF',
        blank: 'ALL'
      }
    },
    getStamps: function () {
      for (let item in stamps) {
        var url = stampsurl.host + '/stamp/' + item
        this.Reloadstamps = {...this.Reloadstamps, [item]: url}
      }
      return this.Reloadstamps
    }
  },
  watch: {
    checkTarget: function () {
      // this.$refs.commentForm.textContent = ''
      this.textContent = ''
      this.comment.contentText = ''
      if (this.uploadImage) {
        this.removeCroppa()
      }
      this.replyUser = ''
      this.comment.contentText = ''
      this.parentInfo.parentId = ''
      this.parentInfo.parentUserId = ''
      this.parentInfo.RootParentId = ''
    },
    selectedStamp: function () {
      console.log('--------selectedStamp is changed --------', this.selectedStamp)
    },
    isEnableCrop () {
      console.log('track:::', this.$refs.cropper, this.isEnableCrop)
      if (this.isEnableCrop) {
        if (this.$refs.cropper) {
          this.$refs.cropper.enable()
        }
      } else {
        if (this.$refs.cropper) {
          this.$refs.cropper.reset()
          this.$refs.cropper.disable()
        }
      }
    }
  },
  updated: function () {
    console.log('uploadImage', this.uploadImage)
    console.log('hasCropperImage', this.hasCropperImage)
  },
  methods: {
    ...mapActions('comments/', {
      sendNewComment: 'SEND_NEW_COMMENT',
      setNewComment: 'SET_NEW_COMMENT'
    }),
    callParent: function (value) {
      this.$emit('send-event', value)
    },
    onClickClose: function () {
      this.$emit('close-event', 'false')
    },
    // プロフィール画像プロップ処理
    onFileTypeMismatch () {
      const $t = this.$t
      this.$swal({
        text: $t('orderFileUploadStr'),
        type: 'warning',
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        padding: '2rem',
        timer: 4000
      })
    },
    handleImageRemove () {
      this.uploadImage = ''
      this.removeCroppa()
      this.hasCropperImage = false
      this.isUploading = false
    },
    // onFileSizeExceed (file) {
    //   const $t = this.$t
    //   this.$swal({
    //     text: $t('order2mbFileStr'),
    //     type: 'warning',
    //     animation: false,
    //     customClass: 'animated pulse'
    //   })
    //   // alert('ファイルは2mb以下でアップロードして下さい。')
    // },
    handleClickEvent: function (evt) {
      const $t = this.$t
      if ((evt.trigger === 'backdrop' || evt.trigger === 'cancel' || evt.trigger === 'header-close') && this.uploadImage) {
        evt.preventDefault()
        this.$swal({
          title: $t('popTitleStrType'),
          text: $t('confirmDeletePictureStr'),
          type: 'warning',
          showCancelButton: true,
          cancelButtonColor: '#f64846',
          confirmButtonClass: 'btn btn-success',
          cancelButtonClass: 'btn btn-danger',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          allowOutsideClick: false,
          padding: '2rem'
          // timer: 5000
        }).then((result) => {
          if (result.value) {
            this.removeCroppa()
            console.log('confirmDeletePictureStr -> true')
          } else {
            console.log('confirmDeletePictureStr -> false')
          }
        })
      } else if ((evt.trigger === 'backdrop' || evt.trigger === 'cancel' || evt.trigger === 'header-close') && !this.uploadImage) {
        this.isEnableCrop = false
        this.$refs.modal.hide()
      } else if (evt.trigger === 'ok' && !this.$refs.cropper.getImageData()) {
        evt.preventDefault()
        this.$swal({
          title: $t('selectPictureStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 5000
        })
      } else if (evt.trigger === 'ok' && this.$refs.cropper.getImageData()) {
        this.uploadResizedPhoto()
      }
    },
    handleStampClickEvent: function (evt) {
      const $t = this.$t
      if (evt.trigger === 'backdrop' || evt.trigger === 'cancel' || evt.trigger === 'header-close') {
        this.selectedStamp = ''
        this.$refs.stampModal.hide()
      } else if (evt.trigger === 'ok' && !this.selectedStamp) {
        evt.preventDefault()
        this.$swal({
          title: $t('selectStampStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          widthRatio: '35rem',
          position: 'center',
          padding: '2rem',
          timer: 5000
        })
      } else if (evt.trigger === 'ok' && this.selectedStamp) {
        this.sendComment(evt)
      }
    },
    StampToUrl: function (key) {
      var url = stampsurl.host + '/stamp/' + key
      return url
    },
    contentTextBlankValidation: function (text) {
      return text.trim().replace(/\r?\n/g, '').length !== 0
    },
    contentTextLimitValidation: function (text) {
      return text.length < 501
    },
    removeCroppa: function () {
      if (this.$refs.cropper) { this.$refs.cropper.destroy() }
      // this.resetFlagForReset()
      this.myCroppa.naturalWidth = 300
      this.myCroppa.naturalHeight = 300
      this.isEnableCrop = false
      this.uploadImage = ''
      this.hasCropperImage = false
      this.isImageUploading = false
      this.$refs.fileInputForm.value = null
      // this.$refs.modal.hide()
    },
    uploadResizedPhoto () {
      this.isImageUploading = true
      let userId = this.getUserId
      var date = moment()
      // var profileImageUrl = date.format('1+YYYY/MM/DD HH:mm') + '.jpg'
      // if (this.isEnableCrop) {}
      var profileImageUrl = (date / 1000) + '.' + this.fileInfo.type
      let storageProfilePhotoRef
      if (this.checkTarget.type === 'rtfbs') {
        storageProfilePhotoRef = storage.ref('rtfb/' + userId)
      } else if (this.checkTarget.type === 'objectives') {
        storageProfilePhotoRef = storage.ref('objective/' + userId)
      } else if (this.checkTarget.type === 'keyresults') {
        storageProfilePhotoRef = storage.ref('keyresult/' + userId)
      } else {
        storageProfilePhotoRef = storage.ref('1on1/' + userId)
      }
      console.log('uploadResizedPhoto:::', storageProfilePhotoRef)
      const path = profileImageUrl
      const photoImagesRef = storageProfilePhotoRef.child(path)
      // generateBlobで、画像からblobオブジェクトを作成します。
      // blobオブジェクトをそのままputメソッドで、Cloud Storageにアップしています。
      this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
        photoImagesRef.put(blob)
          .then((snapshot) => {
            snapshot.ref.getDownloadURL().then((url) => {
              this.uploadImage = url
              this.isImageUploading = false
            })
            // const photoURL = snapshot.downloadURL
            // this.uploadImage = photoURL
          })
          .catch((err) => {
            console.log('upload error:', err)
          })
      })
    },
    // uploadFile () {
    //   let userId = this.getUserId
    //   var date = moment()
    //   // var profileImageUrl = date.format('1+YYYY/MM/DD HH:mm') + '.jpg'
    //   var profileImageUrl = (date / 1000) + '.jpg'
    //   let storageProfilePhotoRef
    //   if (this.checkTarget.type === 'rtfbs') {
    //     storageProfilePhotoRef = storage.ref('rtfb/' + userId)
    //   } else if (this.checkTarget.type === 'objectives') {
    //     storageProfilePhotoRef = storage.ref('objective/' + userId)
    //   } else if (this.checkTarget.type === 'keyresults') {
    //     storageProfilePhotoRef = storage.ref('keyresult/' + userId)
    //   } else {
    //     storageProfilePhotoRef = storage.ref('1on1/' + userId)
    //   }
    //   console.log(storageProfilePhotoRef)
    //   const path = profileImageUrl
    //   const photoImagesRef = storageProfilePhotoRef.child(path)
    //   // generateBlobで、画像からblobオブジェクトを作成します。
    //   // blobオブジェクトをそのままputメソッドで、Cloud Storageにアップしています。
    //   this.myCroppa.generateBlob((blob) => {
    //     photoImagesRef.put(blob)
    //       .then((snapshot) => {
    //         const photoURL = snapshot.downloadURL
    //         this.uploadImage = photoURL
    //       })
    //       .catch((err) => {
    //         console.log('upload error:', err)
    //       })
    //   })
    // },
    onClickReplyReset: function () {
      this.replyUser = ''
      this.parentInfo.parentId = ''
      this.parentInfo.parentUserId = ''
      this.parentInfo.parentUserName = ''
      this.parentInfo.RootParentId = ''
      delete this.comment.parentId
      delete this.comment.parentUserId
      delete this.comment.parentUserName
      delete this.comment.RootParentId
    },
    onPictureSelected (e) {
      const file = e.target.files[0]
      this.hasCropperImage = true
      if (!file.type.includes('image/')) {
        this.hasCropperImage = false
        this.onFileTypeMismatch()
        return
      }
      if (typeof FileReader === 'function') {
        this.isLoaded = false
        const reader = new FileReader()
        reader.onload = (event) => {
          console.log('track:::onread')
          this.imgSrc = event.target.result
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result)
          this.isLoaded = true
        }
        this.isEnableCrop = true
        this.fileInfo = file
        reader.readAsDataURL(file)
      } else {
        this.onFileTypeMismatch()
      }
    },
    rotateImage (deg) {
      if (this.$refs.cropper) {
        this.$refs.cropper.rotate(deg)
      }
    },
    setContentTextByParent: function (parentItem, id) {
      if (parentItem.userName && parentItem.parentId) {
        this.replyUser = '@' + this.getUserInfoById(parentItem.userId).userName + ' '
        this.parentInfo.parentId = id
        this.parentInfo.parentUserId = parentItem.userId
        this.parentInfo.parentUserName = this.replyUser
        this.parentInfo.RootParentId = parentItem.RootParentId
      } else if (parentItem.userName && !parentItem.parentId) {
        this.replyUser = '@' + this.getUserInfoById(parentItem.userId).userName + ' '
        this.parentInfo.parentId = id
        this.parentInfo.parentUserId = parentItem.userId
        this.parentInfo.parentUserName = this.replyUser
        this.parentInfo.RootParentId = id
      } else {
        this.comment.contentText = ''
        this.parentInfo.parentId = ''
        this.parentInfo.parentUserId = ''
        this.parentInfo.parentUserName = ''
        this.parentInfo.RootParentId = ''
      }
      this.focusComment()
    },
    // checkKeyup: function (e) {
    //   if (((e.ctrlKey && !e.metaKey) || (!e.ctrlKey && e.metaKey)) && e.keyCode === 13) {
    //     this.sendComment()
    //   }
    // },
    // contentInExexCommand: function () {
    //   // document.execCommand('insertBrOnReturn', true, null)
    //   console.log('execCommand', this.$refs.commentForm)
    //   console.log('execCommand', this.$refs.commentForm.textContent)
    //   // console.log('textContent::', this.textContent)
    // },
    // sendComment: function (evt) {
    //   console.log('textContent in sendComent::', this.textContent)
    // },
    resetFlagForReset () {
      this.flagForReset = false
      this.$nextTick(function () {
        this.flagForReset = true
      })
    },
    sendComment: function (evt) {
      if (this.selectedStamp) {
        this.comment.contentText = '[stamp key = ' + this.selectedStamp + ']'
        this.comment.isStamp = this.selectedStamp
      } else {
        if (!(this.hasCropperImage ? this.uploadImage !== '' : true)) {
          return
        }
        // if (!this.contentTextBlankValidation(this.$refs.commentForm.textContent)) {
        if (!this.contentTextBlankValidation(this.textContent)) {
          this.$swal({
            text: this.$t('popMessageStrType'),
            type: 'warning',
            animation: false,
            customClass: 'animated fadeInUp',
            // customClass: 'animated flipInX',
            width: '35rem',
            position: 'center',
            // toast: true,
            padding: '2rem',
            timer: 5000
          })
          return
        }
        if (!this.contentTextLimitValidation(this.textContent)) {
          this.$swal({
            text: this.$t('notCharacters'),
            type: 'warning',
            animation: false,
            customClass: 'animated fadeInUp',
            // customClass: 'animated flipInX',
            width: '35rem',
            position: 'center',
            // toast: true,
            padding: '2rem',
            timer: 5000
          })
          return
        }
        this.comment.contentText = this.replyUser + this.textContent
        console.log('this.textContent:::', this.textContent)
      }
      // if (!this.contentTextLimitValidation(this.$refs.commentForm.textContent)) {
      console.log('event', evt)
      // console.log('this.$refs.commentForm.textContent:::', this.$refs.commentForm.textContent)
      // console.log('this.$refs.commentForm:::', getText(this.$refs.commentForm))
      // this.comment.contentText = this.replyUser + this.$refs.commentForm.textContent
      console.log('this.comment.contentText:::', this.comment.contentText)
      this.comment.targetOwner = this.targetOwner
      this.comment.createdAt = new Date().getTime() / 1000
      this.comment.target = this.target
      this.comment.targetId = this.targetId
      this.comment.userId = this.getUserId
      // ユーザーアイコンの有無を判別
      if (this.getCurrentUserInfo.userIcon) {
        this.comment.userIcon = this.getCurrentUserInfo.userIcon
      }
      this.comment.userName = this.getCurrentUserInfo.userName
      if (this.uploadImage && this.uploadImage.length > 0) {
        this.$set(this.comment, 'uploadedFile', this.uploadImage)
      }
      if (this.parentInfo.parentId) {
        console.log('sendComment in if')
        this.comment.parentId = this.parentInfo.parentId
        this.comment.parentUserId = this.parentInfo.parentUserId
        this.comment.parentUserName = this.parentInfo.parentUserName
        this.comment.RootParentId = this.parentInfo.RootParentId
      }
      console.log('commentform', this.comment)
      let targetUserId = this.userId
      let asyncSetNewComment = this.setNewComment
      this.sendCommentAsync(this.comment).then(function (result) {
        result.userId = targetUserId
        return new Promise(function (resolve) {
          let resolveObj = asyncSetNewComment(result)
          resolve(resolveObj)
        })
      }).then(this.resetComment())
    },
    sendCommentAsync: function (comment) {
      let resolveFunction = this.sendNewComment
      return new Promise(function (resolve) {
        let resolveComment = resolveFunction(comment)
        resolve(resolveComment)
      })
    },
    resetComment: function () {
      // this.$refs.commentForm.textContent = ''
      if (!this.selectedStamp) {
        this.textContent = ''
      }
      this.comment.contentText = ''
      this.selectedStamp = ''
      this.comment.isStamp = ''
      // this.$refs.commentForm.resetContentText()
      if (this.uploadImage) {
        delete this.comment.uploadedFile
        this.removeCroppa()
      }
      if (this.parentInfo.parentId) {
        this.replyUser = ''
        this.parentInfo.parentId = ''
        this.parentInfo.parentUserId = ''
        this.parentInfo.RootParentId = ''
        delete this.comment.parentId
        delete this.comment.parentUserId
        delete this.comment.RootParentId
      }
    },
    focusComment: function () {
      // console.log('forcus cooment::')
      this.$refs.commentForm.focusComment()
    },
    onClickStamp: function (item, evt) {
      if (this.selectedStamp === item) {
        this.sendComment(evt)
        this.$refs.stampModal.hide()
      }
    }
  }
}
</script>
<style scoped>
.comment-input .form-control {
  height: auto;
}
.input-group > .form-control {
  max-height: 15em;
  overflow: scroll;
}
.image-uploaded{
  color: #20a8d8;
}
.comment-input{
  padding-top: 7px;
}
.context-form {
  padding: 0;
  outline: none;
  border: none;
  resize: none;
  box-shadow: none;
}
.context-form:active,.context-form:focus, .form-control:focus {
  outline: none;
}
.modal-dialog{
  margin: 10% auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Comment/CommentForm.vue